export interface Worksheet {
  id: string;
  title: string;
  description: string;
  grade: string;
  subject: string;
  topic: string;
  difficulty: 'Beginner' | 'Intermediate' | 'Advanced';
  pages: number;
  isFree: boolean;
  downloadUrl: string;
  thumbnailUrl: string;
}

export const categories = [
  'All',
  'Kindergarten',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7',
  'Grade 8',
  'Grade 9',
  'Grade 10',
  'Grade 11',
  'Algebra 1',
  'Geometry',
  'Algebra 2',
  'Pre-Calculus',
  'SAT Prep',
  'ACT Prep',
  'State Test Grade 3',
  'State Test Grade 4',
  'State Test Grade 5',
  'State Test Grade 6',
  'State Test Grade 7',
  'State Test Grade 8',
  'SHSAT Prep',
  'ACT Math',
  'ACT Science',
  'ACT English'
];

export const subjects = [
  'All Subjects',
  'Math',
  'Algebra',
  'Geometry',
  'Pre-Calculus',
  'Test Prep'
];

export const topics = [
  'All Topics',
  'Counting',
  'Shapes',
  'Patterns',
  'Addition',
  'Subtraction',
  'Multiplication',
  'Division',
  'Fractions',
  'Decimals',
  'Percents',
  'Ratios',
  'Proportions',
  'Integers',
  'Equations',
  'Inequalities',
  'Functions',
  'Linear Functions',
  'Quadratics',
  'Polynomials',
  'Exponential Functions',
  'Logarithms',
  'Trigonometry',
  'Geometry',
  'Measurement',
  'Area and Perimeter',
  'Volume',
  'Angles',
  'Triangles',
  'Circles',
  'Transformations',
  'Coordinate Geometry',
  'Graphing',
  'Word Problems',
  'Probability',
  'Statistics',
  'Operations',
  'Place Value',
  'Time',
  'Money',
  'Exponents',
  'Systems',
  'Complex Numbers',
  'Rational Expressions',
  'Sequences',
  'Conic Sections',
  'Polar Coordinates',
  'Vectors',
  'Limits',
  'Matrices',
  'Full Test',
  'Pre-Algebra',
  'Elementary Algebra',
  'Intermediate Algebra',
  'Plane Geometry',
  'Interpretation of Data',
  'Scientific Investigation',
  'Evaluation of Models',
  'Biology Content',
  'Chemistry Content',
  'Physics Content',
  'Earth/Space Content',
  'Data Representation',
  'Research Summaries',
  'Conflicting Viewpoints',
  'Full Practice',
  'Punctuation',
  'Grammar and Usage',
  'Sentence Structure',
  'Rhetorical Skills',
  'Word Choice and Style',
  'Real Numbers',
  'Linear Equations',
  'Systems of Equations',
  'Factoring'
];